"use client";

import { Button } from "@/components/ui/button";
import { Share2 } from "lucide-react";
import { toast } from "sonner";

type ShareButtonProps = {
  title?: string;
  excerpt?: string;
};

export function ShareButton({ title, excerpt }: ShareButtonProps) {
  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title,
          text: excerpt,
          url: window.location.href,
        });
      } catch (err) {
        // User cancelled or error
        if ((err as Error).name !== "AbortError") {
          console.error("Error sharing:", err);
        }
      }
    } else {
      navigator.clipboard.writeText(window.location.href);
      toast.success("Link copied to clipboard");
    }
  };

  return (
    <Button
      variant="ghost"
      size="icon"
      className="shrink-0 rounded-full border border-[var(--roma-ivory)]/18 bg-[var(--roma-ivory)]/8 text-[var(--primary-foreground)]/72 transition-colors hover:bg-[var(--roma-ivory)]/16 hover:text-[var(--roma-saffron)]"
      onClick={handleShare}
      aria-label="Share article"
    >
      <Share2 className="h-5 w-5" />
    </Button>
  );
}
